import React, { useState } from "react";
import { TextField, MenuItem } from "@mui/material";

const PurchaseOthers = ({ purchaseOthersData, setPurchaseOthersData }) => {
  const locations = ["Dubai", "Abu Dhabi", "Sharjah", "Other"];
  const cAndFAgents = ["Agent A", "Agent B", "Agent C"];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 mt-4">
      <div className="lg:col-span-6 col-span-1 flex flex-col gap-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <TextField
            select
            label="C&F Agent"
            variant="outlined"
            size="small"
            value={purchaseOthersData?.cfAgent || ""}
            onChange={(e) =>
              setPurchaseOthersData({
                ...purchaseOthersData,
                cfAgent: e.target.value,
              })
            }
            fullWidth
          >
            {cAndFAgents.map((agent) => (
              <MenuItem key={agent} value={agent}>
                {agent}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            label="Ship Ref"
            variant="outlined"
            size="small"
            value={purchaseOthersData?.shipRef || ""}
            onChange={(e) =>
              setPurchaseOthersData({
                ...purchaseOthersData,
                shipRef: e.target.value,
              })
            }
            fullWidth
          />
        </div>

        {/* Row 2: Document Date + Location */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <TextField
            label="Document Date"
            type="date"
            variant="outlined"
            size="small"
            value={
              purchaseOthersData?.documentDate ||
              new Date().toISOString().split("T")[0]
            }
            onChange={(e) =>
              setPurchaseOthersData({
                ...purchaseOthersData,
                documentDate: e.target.value,
              })
            }
            InputLabelProps={{ shrink: true }}
            fullWidth
          />

          <TextField
            select
            label="Location"
            variant="outlined"
            size="small"
            value={purchaseOthersData?.location || ""}
            onChange={(e) =>
              setPurchaseOthersData({
                ...purchaseOthersData,
                location: e.target.value,
              })
            }
            fullWidth
          >
            {locations.map((loc) => (
              <MenuItem key={loc} value={loc}>
                {loc}
              </MenuItem>
            ))}
          </TextField>
        </div>
      </div>
    </div>
  );
};

export default PurchaseOthers;
